export default "__VITE_ASSET__ec934e81__"